import { onBeforeMount, watch } from "vue";
import { useRoute } from "vue-router";
import { previewLanguageService } from "@/shared/user/preview-language.service";

export function usePreviewLanguage() {
    const { query = {} } = useRoute() || {};

    return {
        setLanguageFromQuery() {
            onBeforeMount(() => {
                watch(
                    () => query.lang,
                    (newLang) => previewLanguageService.setLanguage(newLang),
                    { immediate: true }
                );
            });
        },
        setLanguageIfNoQuery(lang) {
            if (!query.lang) {
                previewLanguageService.setLanguage(lang || previewLanguageService.fallbackLanguage);
            }
        },
    };
}
